import { render, staticRenderFns } from "./KiPilotPraxisEducationStatus.vue?vue&type=template&id=37ad0180&scoped=true&"
import script from "./KiPilotPraxisEducationStatus.vue?vue&type=script&lang=ts&"
export * from "./KiPilotPraxisEducationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./KiPilotPraxisEducationStatus.vue?vue&type=style&index=0&id=37ad0180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad0180",
  null
  
)

export default component.exports